import { render } from "./CreateRoute.vue?vue&type=template&id=5b2de6d2&scoped=true"
import script from "./CreateRoute.vue?vue&type=script&lang=js"
export * from "./CreateRoute.vue?vue&type=script&lang=js"

import "./CreateRoute.vue?vue&type=style&index=0&id=5b2de6d2&scoped=true&lang=css"

import exportComponent from "/home/adssilicondigital/ads.silicon.digital/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b2de6d2"]])

export default __exports__